import { Injectable } from '@angular/core';
import { PersistenceService } from './persistence.service';
import { EnvironmentService } from './environment.service';
import { IncludeJsService } from './include-js.service';

@Injectable({
  providedIn: 'root'
})
export class GoogleMapsService {

    constructor(private persistenceService:PersistenceService, private environmentService:EnvironmentService, private includeJsService:IncludeJsService) { }

    async loadMaps() {
        if(!this.environmentService.environment.GoogleMapsAPIKey) {
            throw new Error('APIKey missing')
        }
        else if(!this.persistenceService.hasConsentFor('technical_third_party')) {
            throw new Error('Cookie Consent missing')
        }
        else {
            await this.includeJsService.include('https://maps.googleapis.com/maps/api/js?key=' + this.environmentService.environment.GoogleMapsAPIKey + '&libraries=places,geometry', { async: null, defer: null });
        }
    }
}
